/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import styled from 'styled-components';
import { useId } from '@reach/auto-id';
import { TextImage } from '../../molecules/TextImage';
import { media } from '../../../components/themes/theme';
const USPTeaserGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 3.5rem;

  ${media.tablet `
    grid-gap: 2rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}
`;
function isImageObject(image) {
    return typeof image === 'object' && Object.hasOwnProperty.call(image, 'src');
}
export function UniqueSellingPoints({ items }) {
    const key = useId();
    if (key === undefined) {
        return null;
    }
    return (React.createElement(USPTeaserGrid, null, items.map(item => {
        var _a;
        return (React.createElement(React.Fragment, { key: key },
            React.isValidElement(item.image) && (React.createElement(TextImage, { image: item.image, headline: item.headline, headlineAsHTMLTag: item.headlineAsHTMLTag, text: item.text })),
            isImageObject(item.image) && (React.createElement(TextImage, { src: item.image.src, srcSet: (_a = item.image) === null || _a === void 0 ? void 0 : _a.srcSet, alt: item.image.alt, headline: item.headline, headlineAsHTMLTag: item.headlineAsHTMLTag, text: item.text }))));
    })));
}
